import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import Layout from "@/components/Layout";

export default function PaymentCancel() {
  return (
    <Layout>
      <div className="px-4 pt-10 pb-8 text-center max-w-md mx-auto">
        <div className="mx-auto w-20 h-20 rounded-full bg-slate-100 flex items-center justify-center">
          <XCircle className="w-12 h-12 text-slate-500" strokeWidth={2.5} />
        </div>
        <h1 data-testid="payment-cancel-title" className="mt-5 font-heading font-black text-2xl text-brand-blue">Pagamento annullato</h1>
        <p className="mt-2 text-slate-600">Nessun addebito effettuato. I tuoi articoli sono ancora nel carrello.</p>
        <div className="mt-6 flex gap-3 justify-center">
          <Link to="/carrello" data-testid="back-cart-btn" className="bg-brand-blue text-white font-bold rounded-full px-5 py-3 text-sm">
            Torna al carrello
          </Link>
          <Link to="/catalogo" className="bg-white border border-border text-slate-700 font-bold rounded-full px-5 py-3 text-sm">
            Continua a comprare
          </Link>
        </div>
      </div>
    </Layout>
  );
}
